(() => {
  const buttons = document.querySelectorAll('[data-recipe-print-button]');

  if (!buttons.length) {
    return;
  }

  const printStyles = `
    * { box-sizing: border-box; }
    body {
      margin: 0;
      padding: 32px;
      color: #232323;
      font-family: Inter, Arial, sans-serif;
      font-size: 14px;
      line-height: 1.5;
    }
    .recipe-article__print-header {
      margin-bottom: 32px;
    }
    .recipe-article__print-logo {
      display: block;
      width: 180px;
      height: auto;
    }
    .recipe-article__print-content {
      display: grid;
      grid-template-columns: 0.4fr 0.6fr;
      gap: 40px;
      align-items: start;
    }
    .recipe-article__print-section h2 {
      margin: 0 0 18px;
      font-size: 24px;
      line-height: 1.2;
    }
    .recipe-article__print-ingredients {
      display: grid;
      gap: 14px;
      margin: 0;
      padding: 0;
      list-style: none;
    }
    .recipe-article__ingredient-card {
      display: flex;
      align-items: center;
      gap: 10px;
      break-inside: avoid;
    }
    .recipe-article__ingredient-media {
      flex: 0 0 auto;
      width: 42px;
      height: 42px;
      border-radius: 50%;
      overflow: hidden;
      background: #f5f5f5;
    }
    .recipe-article__ingredient-image {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .recipe-article__ingredient-body {
      display: flex;
      flex-wrap: wrap;
      align-items: baseline;
      gap: 2px 6px;
    }
    .recipe-article__ingredient-quantity,
    .recipe-article__ingredient-name,
    .recipe-article__ingredient-notes,
    .recipe-article__ingredient-notes p {
      margin: 0;
    }
    .recipe-article__ingredient-quantity {
      font-weight: 700;
    }
    .recipe-article__ingredient-notes {
      flex: 0 0 100%;
      color: #666;
      font-size: 12px;
    }
    .recipe-article__print-instructions ol {
      counter-reset: recipe-step;
      margin: 0;
      padding: 0;
      list-style: none;
    }
    .recipe-article__print-instructions li {
      counter-increment: recipe-step;
      position: relative;
      min-height: 28px;
      margin-bottom: 14px;
      padding-left: 44px;
      break-inside: avoid;
    }
    .recipe-article__print-instructions li::before {
      content: counter(recipe-step);
      position: absolute;
      top: 0;
      left: 0;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 28px;
      height: 28px;
      border-radius: 50%;
      background: #eeeeee;
      font-weight: 700;
      line-height: 1;
    }
    .recipe-article__print-instructions p {
      margin: 0 0 12px;
    }
    @media print {
      body { padding: 24px; }
    }
  `;

  const escapeHtml = (value) => (
    String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
  );

  const waitForImages = (doc) => {
    const images = Array.from(doc.images);

    if (!images.length) {
      return Promise.resolve();
    }

    return Promise.all(images.map((image) => {
      image.loading = 'eager';

      if (image.complete) {
        return Promise.resolve();
      }

      if (image.decode) {
        return image.decode().catch(() => undefined);
      }

      return new Promise((resolve) => {
        image.addEventListener('load', resolve, { once: true });
        image.addEventListener('error', resolve, { once: true });
      });
    }));
  };

  const buildPrintDocument = (template) => `
      <!doctype html>
      <html>
        <head>
          <meta charset="utf-8">
          <meta name="viewport" content="width=device-width, initial-scale=1">
          <title>${escapeHtml(document.title || 'Recipe Print')}</title>
          <style>${printStyles}</style>
        </head>
        <body>${template.innerHTML}</body>
      </html>
    `;

  const printTemplate = (template) => {
    const iframe = document.createElement('iframe');

    iframe.setAttribute('title', 'Recipe print preview');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    iframe.style.visibility = 'hidden';

    document.body.appendChild(iframe);

    const printDocument = iframe.contentDocument || iframe.contentWindow.document;

    printDocument.open();
    printDocument.write(buildPrintDocument(template));
    printDocument.close();

    waitForImages(printDocument).then(() => {
      const printWindow = iframe.contentWindow;

      printWindow.focus();
      printWindow.print();

      window.setTimeout(() => {
        iframe.remove();
      }, 1000);
    });
  };

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const container = button.closest('.recipe-article__content-inner--prep');
      const template = (container && container.querySelector('[data-recipe-print-template]'))
        || document.querySelector('[data-recipe-print-template]');

      if (!template) {
        window.print();
        return;
      }

      printTemplate(template);
    });
  });
})();
